/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiAdditionalMetricsListFromJSON, ApiAdditionalMetricsListToJSON, } from './ApiAdditionalMetricsList';
import { ApiChartLayoutFromJSON, ApiChartLayoutToJSON, } from './ApiChartLayout';
import { ApiDimensionFromJSON, ApiDimensionToJSON, } from './ApiDimension';
import { ApiMetricFromJSON, ApiMetricToJSON, } from './ApiMetric';
import { ApiMetricsNameMapFromJSON, ApiMetricsNameMapToJSON, } from './ApiMetricsNameMap';
import { ApiTableGroupingFromJSON, ApiTableGroupingToJSON, } from './ApiTableGrouping';
export function ApiChartDisplayOptionsFromJSON(json) {
    return ApiChartDisplayOptionsFromJSONTyped(json, false);
}
export function ApiChartDisplayOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'availableDimensions': !exists(json, 'availableDimensions') ? undefined : (json['availableDimensions'].map(ApiDimensionFromJSON)),
        'availableMetrics': !exists(json, 'availableMetrics') ? undefined : (json['availableMetrics'].map(ApiMetricFromJSON)),
        'disabledDimensionClick': !exists(json, 'disabledDimensionClick') ? undefined : json['disabledDimensionClick'],
        'disabledMetricClick': !exists(json, 'disabledMetricClick') ? undefined : json['disabledMetricClick'],
        'fills': !exists(json, 'fills') ? undefined : json['fills'],
        'filterDropdowns': !exists(json, 'filterDropdowns') ? undefined : (json['filterDropdowns'].map(ApiDimensionFromJSON)),
        'fullAttributesList': !exists(json, 'fullAttributesList') ? undefined : (json['fullAttributesList'].map(ApiDimensionFromJSON)),
        'funnelAdditonalMetrics': !exists(json, 'funnelAdditonalMetrics') ? undefined : (json['funnelAdditonalMetrics'].map(ApiAdditionalMetricsListFromJSON)),
        'funnelAlwaysShowAdditionalMetrics': !exists(json, 'funnelAlwaysShowAdditionalMetrics') ? undefined : json['funnelAlwaysShowAdditionalMetrics'],
        'funnelUseLogFn': !exists(json, 'funnelUseLogFn') ? undefined : json['funnelUseLogFn'],
        'layout': !exists(json, 'layout') ? undefined : ApiChartLayoutFromJSON(json['layout']),
        'metricNames': !exists(json, 'metricNames') ? undefined : (json['metricNames'].map(ApiMetricsNameMapFromJSON)),
        'metricsOrder': !exists(json, 'metricsOrder') ? undefined : json['metricsOrder'],
        'noAttributionToggle': !exists(json, 'noAttributionToggle') ? undefined : json['noAttributionToggle'],
        'noAxis': !exists(json, 'noAxis') ? undefined : json['noAxis'],
        'noFilters': !exists(json, 'noFilters') ? undefined : json['noFilters'],
        'noLegend': !exists(json, 'noLegend') ? undefined : json['noLegend'],
        'noPagination': !exists(json, 'noPagination') ? undefined : json['noPagination'],
        'noReorder': !exists(json, 'noReorder') ? undefined : json['noReorder'],
        'noTitle': !exists(json, 'noTitle') ? undefined : json['noTitle'],
        'pieTotalFontSize': !exists(json, 'pieTotalFontSize') ? undefined : json['pieTotalFontSize'],
        'pieTotalText': !exists(json, 'pieTotalText') ? undefined : json['pieTotalText'],
        'rowsPerPage': !exists(json, 'rowsPerPage') ? undefined : json['rowsPerPage'],
        'showLabels': !exists(json, 'showLabels') ? undefined : json['showLabels'],
        'showTotals': !exists(json, 'showTotals') ? undefined : json['showTotals'],
        'statDesignIndex': !exists(json, 'statDesignIndex') ? undefined : json['statDesignIndex'],
        'statNoBg': !exists(json, 'statNoBg') ? undefined : json['statNoBg'],
        'statTitle': !exists(json, 'statTitle') ? undefined : json['statTitle'],
        'statTitle2': !exists(json, 'statTitle2') ? undefined : json['statTitle2'],
        'tableColWidths': !exists(json, 'tableColWidths') ? undefined : json['tableColWidths'],
        'tableGroupings': !exists(json, 'tableGroupings') ? undefined : (json['tableGroupings'].map(ApiTableGroupingFromJSON)),
        'tablePinAt': !exists(json, 'tablePinAt') ? undefined : json['tablePinAt'],
    };
}
export function ApiChartDisplayOptionsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'availableDimensions': value.availableDimensions === undefined ? undefined : (value.availableDimensions.map(ApiDimensionToJSON)),
        'availableMetrics': value.availableMetrics === undefined ? undefined : (value.availableMetrics.map(ApiMetricToJSON)),
        'disabledDimensionClick': value.disabledDimensionClick,
        'disabledMetricClick': value.disabledMetricClick,
        'fills': value.fills,
        'filterDropdowns': value.filterDropdowns === undefined ? undefined : (value.filterDropdowns.map(ApiDimensionToJSON)),
        'fullAttributesList': value.fullAttributesList === undefined ? undefined : (value.fullAttributesList.map(ApiDimensionToJSON)),
        'funnelAdditonalMetrics': value.funnelAdditonalMetrics === undefined ? undefined : (value.funnelAdditonalMetrics.map(ApiAdditionalMetricsListToJSON)),
        'funnelAlwaysShowAdditionalMetrics': value.funnelAlwaysShowAdditionalMetrics,
        'funnelUseLogFn': value.funnelUseLogFn,
        'layout': ApiChartLayoutToJSON(value.layout),
        'metricNames': value.metricNames === undefined ? undefined : (value.metricNames.map(ApiMetricsNameMapToJSON)),
        'metricsOrder': value.metricsOrder,
        'noAttributionToggle': value.noAttributionToggle,
        'noAxis': value.noAxis,
        'noFilters': value.noFilters,
        'noLegend': value.noLegend,
        'noPagination': value.noPagination,
        'noReorder': value.noReorder,
        'noTitle': value.noTitle,
        'pieTotalFontSize': value.pieTotalFontSize,
        'pieTotalText': value.pieTotalText,
        'rowsPerPage': value.rowsPerPage,
        'showLabels': value.showLabels,
        'showTotals': value.showTotals,
        'statDesignIndex': value.statDesignIndex,
        'statNoBg': value.statNoBg,
        'statTitle': value.statTitle,
        'statTitle2': value.statTitle2,
        'tableColWidths': value.tableColWidths,
        'tableGroupings': value.tableGroupings === undefined ? undefined : (value.tableGroupings.map(ApiTableGroupingToJSON)),
        'tablePinAt': value.tablePinAt,
    };
}
